export default __webpack_public_path__ + "static/media/defly wallet icon.b7e6f70a.png";